<div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-20">
  <div class="max-w-2xl mx-auto">
    @if (_actionDisabled) {
      <div
        (click)="buttonClick.emit()"
        type="button"
        class="relative block w-full border-2 border-dashed rounded-lg p-12 text-center border-edge-strong focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
      >
        <app-ng-icon name="heroFolderPlus" class="text-[48px] text-fg-faint"></app-ng-icon>
        <span class="mt-2 block text-sm font-medium text-fg-muted">
          {{ message }}
        </span>
      </div>
    } @else {
      <button
        (click)="buttonClick.emit()"
        type="button"
        class="relative block w-full border-2 border-edge-strong border-dashed rounded-lg p-12 text-center hover:border-edge-strong focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
      >
        <app-ng-icon name="heroFolderPlus" class="text-[48px] text-fg-faint"></app-ng-icon>
        <span class="mt-2 block text-sm font-medium text-fg-muted">
          {{ message }}
        </span>
      </button>
    }
  </div>
</div>
